// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import tokenReducer from "./tokenSlice";
import ordersReducer from "./orderSlice"; // Import your orders reducer

export default configureStore({
  reducer: {
    token: tokenReducer,
    orders: ordersReducer,
  },
});
